import Vue from 'vue';

export default {
  SAVE_MONTH_REVENUE: (state, { data, message }) => {
    let exist = false;
    for (let i = 0; i < state.revenuePerMonthData.length; i++) {
      if (state.revenuePerMonthData[i].id == data.id) {
        exist = true;
        Vue.set(state.revenuePerMonthData, i, data);
      }
    }
    if (!exist) {
      state.revenuePerMonthData.push(data);
    }
    state.revenuePerMonthNotification = {
      message: message,
      data: data,
      status: 'success'
    };
  },
  SET_ALL_REVENUE_DATA: (state, data) => {
    Vue.set(state, 'revenuePerMonthData', data);
  },
  SET_ERROR_MESSAGES: (state, { messages }) => {
    state.revenuePerMonthNotification = {
      message: messages,
      data: {},
      status: 'error'
    };
  },
  DELETE_MONTH_REVENUE: (state, { revenueDate, revenueProject, message }) => {
    for (let i = 0; i < state.revenuePerMonthData.length; i++) {
      if (state.revenuePerMonthData[i].date == revenueDate && state.revenuePerMonthData[i].project_id == revenueProject) {
        state.revenuePerMonthData.splice(i, 1);
      }
    }
    state.revenuePerMonthNotification = {
      message: message,
      data: {},
      status: 'success'
    };
  }
};
